import { extractLink } from '@atlaskit/link-extractors';
import { getActionsFromJsonLd } from '../../common/actions/extractActions';
export var extractViewAction = function extractViewAction(data) {
  var viewActionExists = getActionsFromJsonLd(data).find(function (action) {
    return action['@type'] === 'ViewAction';
  });
  if (viewActionExists) {
    return {
      viewUrl: extractLink(data)
    };
  }
  return undefined;
};